import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

export class Input extends Component {
    static propTypes = {
      onChange: PropTypes.func,
      name: PropTypes.string,
      type: PropTypes.string,
      initValue: PropTypes.string,
      validators: PropTypes.object
    }

    constructor(props) {
      super(props);

      this.state = {
        value: null
      };

      this.validators = this.props.validators || [];
      this.type = this.props.type || 'text';
      this.error = null;
      this.isUsed = false;
      this.isChanged = false;
    }

    componentDidMount() {
      this.onChange(this.props.initValue || '', false);
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.initValue !== nextProps.initValue) {
        this.onChange(nextProps.initValue, false);
      }
    }

    onChange = (value, isUserChanged = true) => {
      const currentInput = this.ref;

      this.isChanged = isUserChanged || this.isChanged;
      this.error = null;

      if (currentInput) {
        currentInput.classList.remove('is-invalid-input');
      }

      for (let item of this.validators) {
        let result = item(value, this.props);

        if (result && (result.length > 0)) {
          this.error = result;

          if (currentInput && this.isUsed) {

            currentInput.classList.add('is-invalid-input');
          }
          break;
        }
      }

      this.props.onChange({ value: value, error: !!this.error});
      this.setState({ value: value });
    }

    onBlur = (value) => {
      const currentInput = this.ref;

      this.isUsed = true;
      this.error = null;

      if (currentInput) {
        currentInput.classList.remove('is-invalid-input');
      }

      for (let item of this.validators) {
        let result = item(value, this.props);

        if (result && (result.length > 0)) {
          this.error = result;

          if (currentInput && this.isChanged) {
            currentInput.classList.add('is-invalid-input');
          }
          break;
        }
      }

      this.setState({ value: value });
    }

    render() {
      return (
        <React.Fragment>
          <input
            {...this.props}
            className='form-control'
            value={this.state.value}
            onChange={(e) => this.onChange(e.target.value)}
            onBlur={(e) => this.onBlur(e.target.value)}
            ref={(r) => {this.ref = r;}}
          />
          {
            this.isUsed &&
            this.isChanged &&
            this.error &&
            <span className='cls-danger help-block' style={{marginBottom: -15}}>{this.error}</span>
          }
        </React.Fragment>
      );
    }
}

export class TextArea extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    onValidInput: PropTypes.func,
    onhasError: PropTypes.func,
    name: PropTypes.string,
    type: PropTypes.string,
    initValue: PropTypes.string,
    validators: PropTypes.object
  }

  constructor(props) {
    super(props);

    this.state = {
      value: null
    };

    this.validators = this.props.validators || [];
    this.type = this.props.type || 'text';
    this.error = null;
    this.isUsed = false;
    this.isChanged = false;
  }

  componentDidMount() {
    this.onChange(this.props.initValue, false);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.initValue !== nextProps.initValue) {
      this.onChange(nextProps.initValue, false);
    }
  }

  onChange = (value, isUserChanged = true) => {
    const currentInput = this.ref;

    this.error = null;
    this.isChanged = isUserChanged || this.isChanged;

    if (currentInput) {
      currentInput.classList.remove('is-invalid-input');
    }

    for (let item of this.validators) {
      let result = item(value, this.props);

      if (result && (result.length > 0)) {
        this.error = result;

        if (currentInput) {
          currentInput.classList.add('is-invalid-input');
        }
        break;
      }
    }

    this.props.onChange({ value: value, error: !!this.error});
    this.setState({ value: value });
  }

  onBlur = (value) => {
    const currentInput = this.ref;

    this.isUsed = true;
    this.error = null;

    if (currentInput) {
      currentInput.classList.remove('is-invalid-input');
    }

    for (let item of this.validators) {
      let result = item(value, this.props);

      if (result && (result.length > 0)) {
        this.error = result;

        if (currentInput) {
          currentInput.classList.add('is-invalid-input');
        }
        break;
      }
    }

    this.setState({ value: value });
  }

  render() {
    return (
      <React.Fragment>
        <textarea
          {...this.props}
          className='form-control'
          value={this.state.value}
          onChange={(e) => this.onChange(e.target.value)}
          onBlur={(e) => this.onBlur(e.target.value)}
          ref={(r) => {this.ref = r;}}
        />
        {
          this.isUsed &&
          this.isChanged &&
          this.error &&
          <span className='cls-danger help-block' style={{marginBottom: -15}}>{this.error}</span>
        }
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ValidationInput/index.js